import moment from "moment";
import { fetchConToken } from "../../helpers/fetch";
import { handleErrorApi } from "../../helpers/randoms";
import estudiosMedicosServi from "../../services/estudiosMedicosServi";
import { types } from "../../types/types";
import { ESTUDIOS_MEDICOS_ESTADOS, OBRAS_SOCIALES } from "../../utils/constants";
import { startAlerta } from "../ui/alertas";
import { finishSpinner, startSpinner } from "../ui/spinner";

export const clearReducer = () => {
  return { type: types.estudiosMedicosClearReducer };
};

export const cleanEstudiosMedicos = () => ({ type: types.estudiosMedicosClean });


export const setEstadoEstudiosMedicos = (estado) => {
  return {
    type: types.estudiosMedicosUpdateEstado,
    payload: estado,
  };
};

export const setAfiliadoSeleccionado = (afiliado) => {
  return {
    type: types.estudiosMedicosSetAfiliadoSeleccionado,
    payload: afiliado,
  };
};

export const cleanAfiliadoSeleccionado = () => {
  return { type: types.estudiosMedicosCleanAfiliadoSeleccionado };
};

export const setAfiliado = (afiliado) => {
  return {
    type: types.estudiosMedicosSetAfiliado,
    payload: afiliado,
  };
};

export const cleanAfiliado = () => {
  return { type: types.estudiosMedicosCleanAfiliado };
};


export const setEstudioMedicos = (estudio) => {
  return {
    type: types.estudiosMedicosSetSeleccionado,
    payload: estudio,
  };
};

export const getEstadosEstudiosMedicos = () => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());

      const result = await estudiosMedicosServi.getEstadosEstudiosMedicos(
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.estadosEstudiosMedicosGetSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.estadosEstudiosMedicosGetError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los estados de los estudios medicos",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getTipoNotasEstudios = () => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());

      const result = await estudiosMedicosServi.getTipoNotas(
      );
      const body = await result.json();
      if (result.ok) {
        debugger
        dispatch({
          type: types.tipoNotasEstudiosMedicosGetSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.tipoNotasEstudiosMedicosGetError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los tipos de notas de estudios medicos",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getNotasEstudios = (idEstudioMedico) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());

      const result = await estudiosMedicosServi.getNotas(idEstudioMedico
      );
      const body = await result.json();
      if (result.ok) {
        debugger
        dispatch({
          type: types.notasEstudiosMedicosGetSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.notasEstudiosMedicosGetError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las notas de los estudios medicos",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const postNotasEstudiosMedicos = (
  data, close
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await estudiosMedicosServi.postNotas(data)
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta("Nota agregada correctamente",
            "success",
            "Comando Exitoso"
          )
        );
        dispatch(getNotasEstudios(data.idEstudioMedico))
        close();

      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al agregar Nota",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};


export const getEstudiosMedicos = (
  idEstado,
  fechaInicio,
  fechaFin,
  idAfiliado,
  idObraSocial = OBRAS_SOCIALES.OSPEDYC
) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());

      const result = await estudiosMedicosServi.getEstudiosMedicos(
        idEstado,
        fechaInicio,
        fechaFin,
        idAfiliado,
        idObraSocial = OBRAS_SOCIALES.OSPEDYC
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.estudiosMedicosGetSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.estudiosMedicosGetError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los estudios medicos",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getEstudiosMedicosContadores = (
  idEstado,
  fechaInicio,
  fechaFin,
  idAfiliado,
  idObraSocial = OBRAS_SOCIALES.OSPEDYC
) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const result = await estudiosMedicosServi.getEstudiosMedicosContadores(
        idEstado,
        fechaInicio,
        fechaFin,
        idAfiliado,
        idObraSocial = OBRAS_SOCIALES.OSPEDYC
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.estudiosMedicosGetContadoresSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.estudiosMedicosGetContadoresError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los contadores de estudios medicos",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const putEstudiosMedicos = (
  data
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await estudiosMedicosServi.updateEstudiosMedicos(data)
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.estudiosMedicosUpdatePorid,
          payload: body,
        });
        dispatch(setEstudioMedicos(body))
        dispatch(
          startAlerta("Estudio actualizado correctamente",
            "success",
            "Comando Exitoso"
          )
        );

      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        !!data?.idSolicitud
          ? "Error al actualizar receta"
          : "Error al crear la receta",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const FetchDataAfiliado = (idAfiliado) => async (dispatch) => {
  try {
    const response = await fetchConToken(
      `Afiliados/traerPorIdAfiliado/${idAfiliado}`,
    );
    const body = await response.json();

    if (response.ok) {
      dispatch({
        type: types.estudiosMedicosSetAfiliado,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    handleErrorApi(
      dispatch,
      error,
      'Error al cargar la informacion del afiliado.',
      'Ha ocurrido un error. Intente Nuevamente',
    );
  }
};

export const FetchDataAfiliadoExterno = (idObraSocial, nroDocumento) => async (dispatch) => {
  try {
    const response = await fetchConToken(
      `AfiliadosExternos/buscarAfiliadoExternoEnPadron/${idObraSocial}/${nroDocumento}`,

    );
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.setDataAfiliadoHCE,
        payload: body[0],
      });
    } else {
      throw body;
    }
  } catch (error) {
    handleErrorApi(
      dispatch,
      error,
      'Error al cargar la informacion del afiliado.',
      'Ha ocurrido un error. Intente Nuevamente',
    );
  }
};

export const getInformesMedicos = (idAgenda) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const result = await estudiosMedicosServi.getinformesMed(idAgenda);
      const body = await result.json();
      if (result.ok) {
        debugger
        dispatch({
          type: types.informesMedicosGetSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.informesMedicosGetError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los informes medicos",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const cambiarEstadoEstudiosMedicos = (
  data, closeModal, filtros
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      debugger
      const result = await estudiosMedicosServi.cambioEstado(data)
      const body = await result.json();
      debugger
      if (result.ok) {
        dispatch({
          type: types.estudiosMedicosUpdatePorid,
          payload: body,
        });
        dispatch(setEstadoEstudiosMedicos(data.idEstado));
        dispatch(
          startAlerta(
            "Cambio de estado Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
        const fechaInicioFormateada = filtros.fechaInicio ? moment(filtros.fechaInicio).format('YYYY-MM-DD') : null;
        const fechaFinFormateada = filtros.fechaFin ? moment(filtros.fechaFin).format('YYYY-MM-DD') : null;

        dispatch(
          getEstudiosMedicosContadores(filtros.estadoEstudiosMedicos,
            fechaInicioFormateada,
            fechaFinFormateada,
            filtros.idAfiliado,
            filtros.idObraSocial)
        );
        if (!!closeModal) closeModal();
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        !!data?.idSolicitud
          ? "Error al actualizar receta"
          : "Error al crear la receta",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const enviarInformeConImagen = (idAgenda, closeModal, filtros, idEstudio) => {
  debugger
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await estudiosMedicosServi.enviarInformeConImg(idAgenda)
      const body = await response.json();
      if (response.ok) {
        dispatch(startAlerta(`Mail enviado exitosamente`, 'success', 'Comando Exitoso'));
        const data = {
          id: idEstudio,
          idEstado : ESTUDIOS_MEDICOS_ESTADOS.ENVIADOS
         }
        dispatch(cambiarEstadoEstudiosMedicos(data, closeModal, filtros))
        // const fechaInicioFormateada = filtros.fechaInicio ? moment(filtros.fechaInicio).format('YYYY-MM-DD') : null;
        // const fechaFinFormateada = filtros.fechaFin ? moment(filtros.fechaFin).format('YYYY-MM-DD') : null;
        // dispatch(
        //   getEstudiosMedicosContadores(filtros.estadoEstudiosMedicos,
        //     fechaInicioFormateada,
        //     fechaFinFormateada,
        //     filtros.idAfiliado,
        //     filtros.idObraSocial)
        // );
        // if (!!closeModal) closeModal();
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        err,
        "Ocurrio un error en el envío del PDF",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};


export const enviarEstudioImagen = (idAgenda, closeModal, filtros, idEstudio) => {
  debugger
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await estudiosMedicosServi.enviarEstudioConImg(idAgenda)
      const body = await response.json();
      debugger
      if (response.ok) {
        dispatch(startAlerta(`Mail enviado exitosamente`, 'success', 'Comando Exitoso'));
        const data = {
          id: idEstudio,
          idEstado : ESTUDIOS_MEDICOS_ESTADOS.ENVIADOS
         }
        dispatch(cambiarEstadoEstudiosMedicos(data, closeModal, filtros));
        // const fechaInicioFormateada = filtros.fechaInicio ? moment(filtros.fechaInicio).format('YYYY-MM-DD') : null;
        // const fechaFinFormateada = filtros.fechaFin ? moment(filtros.fechaFin).format('YYYY-MM-DD') : null;
        // dispatch(
        //   getEstudiosMedicosContadores(filtros.estadoEstudiosMedicos,
        //     fechaInicioFormateada,
        //     fechaFinFormateada,
        //     filtros.idAfiliado,
        //     filtros.idObraSocial)
        // );
        // if (!!closeModal) closeModal();
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        err,
        "Ocurrio un error en el envío del PDF",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getTrackingEstudiosMedicos = (idEstudioMedico) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());

      const result = await estudiosMedicosServi.getTracking(idEstudioMedico);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.trackingEstudiosMedicosGetSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.trackingEstudiosMedicosGetError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener el tracking estudios medicos",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};
